import React, { useEffect, useState } from "react";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import { getMachineImportPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { MACHINE_MASTER_IMPORT } from "../../constants/routes";
import {FileTemplateDownloader, FileUploader, RedirectAlert} from "../../components";
import { API_MACHINE_DOWNLOAD_TEMPLATE } from "../../constants/api";
import { PageTitle } from "../../components";
import BackendLayout from "../../layouts/BackendLayout";
import PageAlert from "../../components/alerts/PageAlert";
import {
  clearPageLoading,
  resetAlert,
  setAlertSuccess,
  setPageLoading,
  setButtonProcessing,
  clearButtonProcessing
} from "../../store/actions";
import { importMachine } from "../../api/machine/machineApi";
import {errorStatusHandle} from "../../utils";
import { setImportFileAlertError } from "../../store/actions";
import {MACHINE_MASTER_IMPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

function PositionImportPage() {
  useRedirectPage(MACHINE_MASTER_IMPORT_PAGE);
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();

  const setMachineImportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getMachineImportPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setMachineImportPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const breadcrumb = getRouteBreadcrumb(MACHINE_MASTER_IMPORT);
  useDocumentTitle("設備マスタインポート - 点検王");

  const handleChangeFileChange = (file) => {
    setSelectedFile(file);
    dispatch(resetAlert());
  };

  const BUTTON_IMPORT_MACHINE = 'button__import-machine';
  const handleUpload = () => {
    dispatch(setButtonProcessing(BUTTON_IMPORT_MACHINE));
    dispatch(resetAlert());
    const formData = new FormData();
    formData.append("file", selectedFile);
    importMachine(formData)
      .then((response) => {
        dispatch(setAlertSuccess(response.message));
        setSelectedFile(null);
      })
      .catch((error) => {
        errorStatusHandle(error);
        if (error.status === 400) {
          let responseData = error.data;
          dispatch(setImportFileAlertError(responseData));
        }
      }).finally(() => {
        dispatch(clearButtonProcessing(BUTTON_IMPORT_MACHINE));
    });
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="設備マスタインポート" />
      <RedirectAlert />
      <PageAlert />
      <div className="lg:flex mt-6 2xl:space-x-[32px] xl:space-x-[28px] lg:space-x-[24px] lg:space-y-0 md:space-y-[24px]">
        <FileUploader
          title="ファイルをアップロード"
          description="設備をインポートしたいファイルをアップロードしてください"
          file={selectedFile}
          handleUpload={handleUpload}
          handleChangeFileChange={handleChangeFileChange}
          buttonId={BUTTON_IMPORT_MACHINE}
        />
        <FileTemplateDownloader
          title="テンプレートファイル"
          description="テンプレートファイルを持っていない場合、インポートに使用するファイルをこちらからダウンロードしてください。"
          apiUrl={API_MACHINE_DOWNLOAD_TEMPLATE}
          buttonId="download-machine-template"
        />
      </div>
    </BackendLayout>
  );
}

export default PositionImportPage;
